function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "more-vert"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.52,15a3.75,3.75,0,1,0-3.75,3.74A3.76,3.76,0,0,0,7.52,15Zm3.74,0A3.74,3.74,0,1,0,15,11.26,3.75,3.75,0,0,0,11.26,15Zm11.22,0a3.75,3.75,0,1,0,3.75-3.74A3.76,3.76,0,0,0,22.48,15Z",
  transform: "translate(-0.03 -11.26)"
}));

var SvgShowMore = function SvgShowMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ShowMore1",
    "data-name": "Capa 1",
    viewBox: "0 0 29.93 7.48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShowMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ShowMore.542b0add.svg";
export { ForwardRef as ReactComponent };